import React, { FC, useContext, useEffect } from "react";
import confetti from "canvas-confetti";

import { SocketContext, TeamContext }from "../../../../context";
import { useSound } from "../../../../hooks";
interface CustomHTMLElement extends HTMLCanvasElement{
    confetti: any;
}

const ActivationCelebration: FC<{}> = () => {
    const { nextPhaseConffeti } = useContext(SocketContext);
    const { game } = useContext(TeamContext);
    const gameRoundNumber: number = game?.gameInfo?.challengeScore || 0;
    const isAfterRound3: boolean = gameRoundNumber > 3;
    const {playSound} = useSound();

    const addConfetti = () => {
        const htmlCanvas = document.getElementById("confeti") as CustomHTMLElement;
        
        htmlCanvas!.confetti = htmlCanvas!.confetti || confetti.create(htmlCanvas, { resize: true });
        htmlCanvas!.confetti({
            particleCount: 100,
            angle: 90,
            spread: 180,
            gravity: 1,
            zIndex: 1,
            startVelocity: 50,
            scalar: 2,
            colors: ["#53BD8B", "#FF00A7", "#005776", "#FED100" ],
            resize: true
        });
    }

    useEffect(() => {
        if(isAfterRound3) {
            nextPhaseConffeti(10000);
        } else {
            nextPhaseConffeti(2000);
        }
        addConfetti();
    }, [nextPhaseConffeti])

    useEffect(() => {
        const timeout = setTimeout(() => {
            playSound("/sounds/MergedYay.mp3")
        },10); 

        return () => clearTimeout(timeout);
        
    },[playSound]);

    useEffect(() => {
        const timeout = setTimeout(() => {
            playSound("/sounds/CoinCollect.mp3")
        },2250); 

        return () => clearTimeout(timeout);
        
    },[playSound]);

    useEffect(() => {
        const timeout = setTimeout(() => {
            playSound("/sounds/PositiveAlert3.mp3")
        },3500); 

        return () => clearTimeout(timeout);
        
    },[playSound]);
    
    return(
        <React.Fragment>
            <canvas id="confeti" style={{position: 'absolute', top: '0', width:'99%', zIndex: 1, borderRadius:'50%'}} />
        </React.Fragment>
        
    );
}

export default ActivationCelebration;